import PaperMascot from "./PaperMascot";
import PencilMascot from "./PencilMascot";
import { CAST, FACES, PERSONALITY_FACES, stillFace } from "./mascotMood";

/**
 * Draws a mascot descriptor ({ base, color, face, accessory? }) in any mood.
 * "calm" shows its resting personality face; other moods (timer, reactions)
 * take over while they apply. `still` drops the looping animations, for
 * mascots that sit in lists and only move while reacting.
 */
export default function MascotAvatar({ mascot = CAST.namey, mood = "calm", letter, size = 72, variant = "full", shadow, still = false, label = "", className }) {
  const rest = PERSONALITY_FACES[mascot.face]?.face || PERSONALITY_FACES.cheerful.face;
  let face = mood === "calm" ? rest : FACES[mood] || rest;
  if (mascot.accessory === "crown") face = { ...face, lashes: true };
  if (still) face = stillFace(face);

  if (mascot.base === "pencil") {
    return <PencilMascot face={face} color={mascot.color} size={size} shadow={shadow ?? variant === "full"} label={label} className={className} />;
  }
  return (
    <PaperMascot
      letter={letter}
      face={face}
      color={mascot.color}
      accessory={mascot.accessory}
      size={size}
      variant={variant}
      shadow={shadow}
      label={label}
      className={className}
    />
  );
}
